// Import Map from 'core-js/library/es6/map';

export const PROJECT_OLSZTYN = 47;
export const PROJECT_OLSZTYN_SZKOLENIA = 48;

export const PROJECTS = new Map([
  [PROJECT_OLSZTYN, 'PROJECT_OLSZTYN'],
  [PROJECT_OLSZTYN_SZKOLENIA, 'PROJECT_OLSZTYN']
]);
